import type { Department } from '#shared/types';
import { Badge } from '#client/components/ui/Badge';
import type { Column } from '#client/components/ui/DataTable';
import { ResourceListPage } from '#client/components/ui/ResourceListPage';
import { RESOURCE } from '#client/lib/routes';

const columns: Column<Department>[] = [
  { key: 'name', header: 'Department', render: (row) => <strong>{row.name}</strong> },
  {
    key: 'code',
    header: 'Code',
    width: '120px',
    render: (row) => <span className="ident">{row.code}</span>,
  },
  {
    key: 'sort_order',
    header: 'Order',
    width: '90px',
    align: 'end',
    render: (row) => <span className="tnum">{row.sort_order}</span>,
  },
  {
    key: 'is_active',
    header: 'Status',
    width: '110px',
    render: (row) =>
      row.is_active ? <Badge tone="success">Active</Badge> : <Badge tone="neutral">Inactive</Badge>,
  },
];

export function DepartmentListPage() {
  return (
    <ResourceListPage<Department>
      title="Departments"
      subtitle="The benches a lab test belongs to. Order controls how the printed rate list reads."
      path={RESOURCE.departments}
      columns={columns}
      noun="department"
      nounPlural="departments"
      searchPlaceholder="Search by name or code"
      rowLabel={(row) => row.name}
      createCapability="department.create"
      editCapability="department.edit"
      deleteCapability="department.delete"
      emptyBody="Departments group the rate list and the stock-entry screens."
    />
  );
}
